import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeAddBtn from "../../../global-components/forms/add-btn.js";
import makeHeader from "../../../global-components/header.js";
import SettingsBtn from "../../../global-components/settings-btn.js";
import APP_COMPONENTS from "../components/index.js";
import APP_VIEWS from "./event-router.js";
import APP_EVENTS from "./events.js";
export default function App({ settingsBtn, settingsOverlay, header, logo, addBtn }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent,
        executeEventWithData,
        executeFormEventWithData
    });
    function _initAppShell() {
        SettingsBtn({ settingsBtn, settingsOverlay }).init();
        makeHeader({ header, logo }).init();
        makeAddBtn({
            addBtn,
            events: APP_EVENTS,
            action: 'add-show-clicked'
        }).init();
        APP_COMPONENTS.showsForms.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = APP_VIEWS.getWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFormEventWithData(detail) {
        const view = APP_VIEWS.getFormActionWithData(detail.action);
        await view.execute(detail.data);
    }
}
;
